import React, { useState } from 'react';
import { PivotBasicTab } from 'components';
import moveIcon from 'images/SVG/group-2.svg';
import {
	mergeStyleSets,
} from 'office-ui-fabric-react';
import { childNodesCheckbox, childNodesExpand } from '../../outPut/OutPutAction';
import { useDispatch, useSelector } from 'react-redux';
import { selectMetrics, updateXDEMetrics, updateXDEMetricsOrder } from '../redux/PhoenixActions';


const styles = mergeStyleSets({
	root: [
		{
			selectors: {
				'::before': {
					background: '#ccc',
				},
			},
		},
	],
	fileIconCell: {
		textAlign: 'center',
		width: '28px',
		selectors: {
			'&:before': {
				content: '.',
				display: 'inline-block',
				verticalAlign: 'middle',
				height: '100%',
				width: '28px',
				visibility: 'hidden',
			},
		},
	},
	fileIconImg: {
		verticalAlign: 'middle',
		maxHeight: '16px',
		maxWidth: '16px',
	},
});

const outputColumns = [
	{
		key: 'column1',
		name: 'moveIcon',
		className: styles.fileIconCell,
		iconClassName: styles.fileIconImg,
		ariaLabel: 'Move Icon',
		iconName: 'Move',
		isIconOnly: true,
		fieldName: 'moveIcon',
		minWidth: 16,
		maxWidth: 16,
		iconPath: { moveIcon },
	},
	{
		key: 'column2',
		name: 'Name',
		fieldName: 'colText',
	},
];

const MetricsConfigurationStep = () => {
	const dispatch = useDispatch();

	const metrics = useSelector(state=>state.data.phoenixReducers.metrics.xdeMetrics);
	const arrangeFields = useSelector(state=>state.data.phoenixReducers.metrics.xdeMetricsOrder);
  
	const onExpandClick = event => {
		const colId = event.target.id.split('-');
		const nodes = [...metrics];
		// childNodesExpand(nodes, colId);
		dispatch(updateXDEMetrics({data:nodes, colId:colId}));
	};

	const onSelect = (event) => {
		const metricss = [...metrics];
		// childNodesCheckbox(metricss, event.target.checked, event.target.id);	
		//setMetrics(metricss);
		if (event.target.id.split('|').length > 1) {
			dispatch(
				selectMetrics({
					data: {
						metric: event.target.id.split('|')[0],
						timeperiod: event.target.id.split('|')[1],
					},
					checked: event.target.checked,
				}),
			); // metrics : metricss
		} else {
			dispatch(
				selectMetrics({
					data: { metric: event.target.id, timeperiod: null },
					checked: event.target.checked,
				}),
			); // metrics : metricss
		}
	}

	const handleMetricsOrderChange = (arrangeFields) => {
			dispatch(updateXDEMetricsOrder({data:arrangeFields}));
		}


	return (
		<div className="ms-Grid out-put-container " dir="ltr">
			<PivotBasicTab
				fields={metrics}
				columns={outputColumns}
				arrangeFields={arrangeFields}
				onSelect={onSelect}
				handleDragDropEvents={handleMetricsOrderChange}
				isArrangeField={true}
				onLinkClick={() => console.log('output node selected: ')}
				onExpandClick={onExpandClick}
			/>
		</div>
	);
};

export default MetricsConfigurationStep;
